import { Link } from 'react-router-dom';
import { Sparkles, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-8 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          {/* Left: Logo */}
          <div>
            <Link to="/" className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-gradient-to-br from-primary-400 to-primary-600 rounded-lg flex items-center justify-center">
                <Sparkles className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold text-white">Niro Labs</span>
            </Link>
          </div>

          {/* Center: Tagline */}
          <div className="text-center">
            <p className="text-gray-400 text-sm">
              Modern web and cloud development solutions
            </p>
          </div>

          {/* Right: Contact & Copyright */}
          <div className="text-right space-y-2">
            <a
              href="mailto:contact@nirolabs.ai"
              className="inline-flex items-center space-x-2 text-gray-400 hover:text-primary-400 transition-colors text-sm"
            >
              <Mail className="w-4 h-4" />
              <span>contact@nirolabs.ai</span>
            </a>
            <p className="text-gray-500 text-xs">
              © {currentYear} Niro Labs LLC
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;